import React from 'react'
import Modal from '../Modal'
import Loader from '../Loader'

interface IProps {
  isLoading: boolean
  text?: string
  style?: React.CSSProperties
  modalStyle?: React.CSSProperties
  fontWeight?: number
  margin?: string
  fontSize?: string
}

const ModalLoader = ({ isLoading, text, style, modalStyle, fontWeight, margin, fontSize }: IProps) => {
  return (
    <Modal
      onlyContent
      show={isLoading}
      style={{
        background: 'rgba(255, 255, 255, 0.72)',
        backdropFilter: 'blur(8px)',
        ...modalStyle,
      }}
      setShow={() => {}}
    >
      <Loader
        margin={margin}
        fontSize={fontSize}
        fontWeight={fontWeight}
        style={{
          padding: '28px 32px',
          borderRadius: '24px',
          background: 'rgba(255, 255, 255, 0.82)',
          boxShadow: '0 24px 48px rgba(23, 55, 77, 0.12)',
          ...style,
        }}
        text={text}
      />
    </Modal>
  )
}

export default ModalLoader
